import type { ActivityOperationsFilters } from "../types/activityOperations.types";

export const ACTIVITY_OPERATIONS_QUERY_KEYS = {
  all: ["activity-operations"] as const,
  list: (filters: ActivityOperationsFilters, sortParams: string[] = []) =>
    [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "list", filters, sortParams] as const,
  balance: (filters: ActivityOperationsFilters) => [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "balance", filters] as const,
  modules: () => [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "modules"] as const,
  references: (categorie?: string, familleId?: string) =>
    [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "references", categorie ?? "all", familleId ?? "all"] as const,
  genres: (categorie?: string) => [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "genres", categorie ?? "all"] as const,
  familles: (categorie?: string, genreId?: string) =>
    [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "familles", categorie ?? "all", genreId ?? "all"] as const,
  invoiceAccountingLines: (invoiceId: string, showSettled: boolean) =>
    [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "invoice-accounting-lines", invoiceId, showSettled] as const,
  invoiceDetail: (invoiceId: string) => [...ACTIVITY_OPERATIONS_QUERY_KEYS.all, "invoice", invoiceId] as const,
} as const;
